export const actionTypes = {
    SATELLITE_OVERLAY_ADD: 'SATELLITE/OVERLAY_ADD',
    SATELLITE_OVERLAY_REMOVE: 'SATELLITE_OVERLAY_REMOVE',
};
